import type { VAxios } from '../../define/axios/Axios';
import { GetCurrentRes } from '../../entities/cc/users.entities';

export const createApi = (defHttp: VAxios) => ({
  // 获取当前用户拥有的权限code
  getPermissions: () => {
    return defHttp.post({ url: '/aiad/users/permissions' });
  },

  // 获取当前用户信息
  getCurrent: () => {
    return defHttp.get<GetCurrentRes>({ url: '/aiad/users/current' });
  },

  // 获取随机名称
  randomName: () => {
    return defHttp.get<string>({ url: '/aiad/users/random-name' });
  },

  // 切换用户的工作流
  switchSolution: (solution: string) => {
    return defHttp.put({
      url: `/aiad/users/solution?solution=${solution}`,
    });
  },
});
